import { React } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,from
} from '@apollo/client';
import { onError } from "@apollo/client/link/error";
import { setContext } from '@apollo/client/link/context';

import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";

import Auth from './utils/auth';

import Home from './pages/Home';
import Detail from './pages/Detail';
import NoMatch from './pages/NoMatch';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Nav from './components/Nav';
import Success from './pages/Success';
import OrderHistory from './pages/OrderHistory';
import AffiliatePage from './pages/AffiliatePage';
import Footer from './components/Footer';
import Cart from './components/Cart';
import Privacy from './pages/Privacy';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogEdit from './pages/BlogEdit';
import ProductList from './components/ProductList';
import OrderCancel from './pages/OrderCancel';
import ReturnPolicy from './pages/ReturnPolicy';
import Admin from './pages/Admin';
import AdminLinks from './pages/AdminLinks';
import AdminProducts from './pages/AdminProducts';

const isPublicEnvironment = process.env.REACT_APP_ENVIRONMENT === 'public';

if (isPublicEnvironment) {
  //
} else {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

const httpLink = createHttpLink({
  uri: '/graphql',
});

const authLink = setContext((gqlRequest, { headers }) => {
  const token = Auth.getToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
      ),
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const client = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({resultCaching: false}) //FIXME: ?? process.env.NODE_ENV === 'public' ??
});

function App() {
  const currentUser = useSelector(state => state.currentUser);

  return (
    <ApolloProvider client={client}>
      <Router>
        <div className="content">

          <Nav />

          {currentUser && currentUser.admin && <Cart />}

          <main>
            <Routes>
              <Route exact path="/" element={<Home/>} />
              <Route exact path="/affiliate/:id" element={<AffiliatePage/>} />
              <Route exact path="/blog" element={<Blog/>} />
              <Route exact path="/blog/:id" element={<BlogPost/>} />
              <Route exact path="/blog/add" element={<BlogEdit/>} />
              <Route exact path="/blog/edit/:id" element={<BlogEdit/>} />
              <Route exact path="/privacy" element={<Privacy/>} />
              <Route exact path="/our-products/:category_slug" element={<ProductList/>} />
              <Route exact path="/success" element={<Success/>} />
              <Route exact path="/cancel" element={<OrderCancel/>} />
              <Route exact path="/orderHistory" element={<OrderHistory/>} />
              <Route exact path="/return-policy" element={<ReturnPolicy/>} />
              <Route exact path="/admin" element={<Admin/>} />
              <Route exact path="/admin-links" element={<AdminLinks/>} />
              <Route exact path="/admin-products" element={<AdminProducts/>} />
              <Route exact path="/login" element={<Login/>} />
              { /*
              <Route exact path="/signup" element={<Signup/>} />
              <Route exact path="/products/:id" element={<Detail/>} />
              */ }
              <Route element={<NoMatch/>} />
            </Routes>
          </main>

          <Footer />

        </div>
      </Router>
    </ApolloProvider>
  );
}

export default App;
